import PropTypes from 'prop-types';
import React from 'react';

import tmovLogo from '../../assets/images/tmov-logo.png';
import tmovLogoSidebar from '../../assets/images/tmov-logo-sidebar.png';
import { Container, Divider, Logo, Name } from './styles';

const Brand = ({ size, isCollapsed, type }) => (
  <Container>
    <Logo
      alt="logo da sotran"
      src={type === 'sidebar' && !isCollapsed ? tmovLogoSidebar : tmovLogo}
      size={!isCollapsed ? size : 'sm'}
    />
    {type === 'login' && (
      <>
        <Divider
          type="vertical"
          iscollapsed={isCollapsed ? 1 : 0}
          data-testid="brand-divider"
        />
        <Name iscollapsed={isCollapsed ? 1 : 0} size={size}>
          SHIPPER
        </Name>
      </>
    )}
  </Container>
);

Brand.propTypes = {
  isCollapsed: PropTypes.bool,
  size: PropTypes.string,
  type: PropTypes.string,
};

Brand.defaultProps = {
  isCollapsed: false,
  size: 'md',
  type: 'login',
};

export default Brand;
